import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Button } from '@change-corgi/design-system-legacy/components/actions';

import { useCTAButtonVariant } from 'src/app/pages/starterDashboardV2/shared/contexts';
import { useSharePetitionButton } from 'src/app/pages/starterDashboardV2/shared/hooks';

export function SharePetitionButton(): JSX.Element {
	const {
		actions: { handleShareClick },
	} = useSharePetitionButton();
	const { getCTAVariant } = useCTAButtonVariant();

	return (
		<Button
			data-testid="share-petition-button"
			data-qa="share-petition-button"
			variant={getCTAVariant('secondaryEmphasis')}
			size="medium"
			onClick={async () => handleShareClick()}
		>
			<Translate value="corgi.petition.starter_dashboard.grow_petition.share_petition.share_cta" />
		</Button>
	);
}
